import { render } from "./FormUpdatePassword.vue?vue&type=template&id=245be765"
import script from "./FormUpdatePassword.vue?vue&type=script&lang=js"
export * from "./FormUpdatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__